/**
 * @description 登入頁面切換用
 */
export enum LoginStep {
  /** 會員登入頁 */
  MemberLogin = 1,
  /** 身份驗證頁 */
  Authentication = 2,
  /** OTP驗證頁 */
  OTPVerification = 3,
  /** 詢問安全問題頁 */
  SecurityQuestion = 4,
  /** 修改會員資料提示頁 */
  MemberVerifyComplete = 5
}
